"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const $ = require("jquery");
const initTestimonialsSlider = () => {
    const testimonialsSliders = $('.testimonials__slider-slick');
    testimonialsSliders.each(function () {
        const testimonialsSlider = $(this);
        const options = {
            arrows: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            autoplaySpeed: 5000,
            draggable: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            autoplay: false,
            dots: false,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        mobileFirst: true,
                        swipeToSlide: true,
                        dots: false,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        adaptiveHeight: false,
                        swipeToSlide: true,
                        dots: false,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        swipeToSlide: true,
                        dots: true,
                    }
                }
            ]
        };
        testimonialsSlider.slick(options);
        testimonialsSlider.on('touchend touchcancel touchmove', () => {
            testimonialsSlider.slick('slickPlay');
        });
        $('.testimonials__arrows .arrow-prev').click(() => {
            testimonialsSlider.slick('slickPrev');
        });
        $('.testimonials__arrows .arrow-next').click(() => {
            testimonialsSlider.slick('slickNext');
        });
    });
};
$(document).ready(() => {
    initTestimonialsSlider();
});
